import React, {useMemo, useRef, useState,useEffect} from "react";
import Icons from "../../UI/Icons";
import Buttons from "../../UI/Buttons";
import Acl from "../../../hoc/Acl";
import { Link, useLocation } from "react-router-dom";
import { isSet } from "../../../utils/commonUtils";
import { isBelowBootstrapLg } from "../../../utils/responsiveBreakpoints";
import Button from "../../UI/Buttons/Button";
import NewHeader from "./NewHeader";
// import Wrap from "../../../hoc/Wrap";
// import { useNavigate } from "react-router-dom"

const NewMenus = (props) => {
  const {sideBarChangeHandler,currentPath}=props;
  const menuRef = useRef(null);
  const [submenuPosition, setSubmenuPosition] = useState({});
  const menuItemRef = useRef(null);
  const submenuRef = useRef(null);
  const [configureActive,setConfigureActive] = useState(false);
  const [navExpanded, setNavExpanded] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [isTabletNav, setIsTabletNav] = useState(false);
  const location = useLocation();

  const getSafeMenuAttrs = (rawAttrs, { isTablet, hasSubmenu }) => {
    const attrs = { ...(isSet(rawAttrs, {})) };
    if (isTablet && hasSubmenu) {
      // In tablet mode we handle submenu toggling in React; remove Bootstrap triggers to avoid
      // bootstrap.bundle trying to toggle a non-existent target and throwing classList null errors.
      delete attrs['data-bs-toggle'];
      delete attrs['data-toggle'];
      delete attrs['data-bs-target'];
      delete attrs['data-target'];
      delete attrs['aria-haspopup'];
    }
    return attrs;
  };

  const flattenedAclArray = useMemo(()=>{
    return props.Configures.flatMap(item => Array.isArray(item.acl) ? item.acl.flat() : [item.acl]);
  },[props.Configures]);
  

//use effect for active menu configure
  useEffect(() => {
    const isActive = props.Configures.some(menu => location.pathname === menu.link);
    setConfigureActive(isActive);
  }, [location.pathname, props.Configures]);

  useEffect(() => {
    const compute = () => {
      const tablet = isBelowBootstrapLg();
      setIsTabletNav(tablet);
      if (!tablet) {
        setNavExpanded(false);
        setOpenSubmenu(null);
      }
    };
    compute();
    window.addEventListener('resize', compute);
    return () => window.removeEventListener('resize', compute);
  }, []);

  useEffect(() => {
    if (!navExpanded) setOpenSubmenu(null);
  }, [navExpanded]);
  const handleClickOutside = (event) => {
    if(isSet(submenuRef.current) && submenuRef.current.classList.contains('show') && !submenuRef.current.contains(event.target)){
      submenuRef.current.classList.remove('show');
    }else if(isSet(event.target.closest('a')) && event.target.closest('a').hasAttribute('data-bs-toggle')){
      props.removeSideBar();
    }
    
    if (
      submenuRef.current &&
      !submenuRef.current.contains(event.target) &&
      menuItemRef.current &&
      !menuItemRef.current.contains(event.target)
    ) {
      
      const parentNodeList = submenuRef.current.parentNode;
      try{
        if(submenuRef.current.classList.contains('show')){
          if(!event.target.closest('a').hasAttribute('data-bs-toggle')){
            parentNodeList.querySelector('a').click();
          }
          
        }
      }catch(e){

      }
      
      // submenuRef.current.parentNode.querySelector('a').click();
    }else if(
      submenuRef.current &&
      menuItemRef.current &&
      !menuItemRef.current.contains(event.target)){
        const parentNodeList = submenuRef.current.parentNode;
        if(event.target.classList.contains('collapse-item')){
          setTimeout(() => {
            parentNodeList.querySelector('a').click();
          }, 500);
        }
      // collapse-item
    }
  };
  useEffect(() => {
    if (menuItemRef.current) {
      const rect = menuItemRef.current.getBoundingClientRect();
      // console.log('rect',rect);
      setSubmenuPosition({ top: (rect.top), left: rect.left });
    }
   

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props.activeMenu]);
    useEffect(() => {
    const body = document.body;
    body.classList.remove("sidebar-toggled");
    }, []);
  const toggleSidebar = () => {
    document.body.classList.toggle('sidebar-toggled');
    document.querySelector('.sidebar').classList.toggle('toggled');
    if (document.querySelector('.sidebar').classList.contains('toggled')) {
      document.querySelectorAll('.sidebar .collapse').forEach(el => el.classList.remove('show'));
    }
  };

  const handleSubMenuClick = (event) =>{
    if(isSet(submenuRef.current) && submenuRef.current.classList.contains('show') && submenuRef.current.contains(event.target)){
      submenuRef.current.classList.remove('show');
    }
  }

  return (
     <nav className="navbar navbar-expand-lg topbar fixed-top">
      {/* icon */}
      {/* <div>
        <a
          className="sidebar-brand "
          role="button"
          style={{ cursor: 'default' }}
        >
          <div className="sh_logoIcon">
            <div className="sidebar-brand-icon">
              <Icons type={`Logo`} />
            </div>
          </div>
        </a>
      </div> */}
         <div className="d-flex align-items-center d-lg-none">   
          <button 
        className="navbar-toggler border-0 shadow-none ml-2" 
        type="button" 
        onClick={() => setNavExpanded(!navExpanded)}
        aria-controls="navbarMain" 
        aria-expanded={navExpanded} 
        aria-label="Toggle navigation"
      >
        <span className="">
        <svg width="24px" height="24px" viewBox="0 0 24 24" id="" xmlns="http://www.w3.org/2000/svg"><g id="menu-Filled"><path id="menu-Filled-2" data-name="menu-Filled" class="cls-1" d="M2,5A1,1,0,0,1,3,4H16a1,1,0,0,1,0,2H3A1,1,0,0,1,2,5Zm19,6H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm-9,7H3a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"/></g></svg>       
         </span>
      </button>
      </div>
      <div>
      <div class="sidebar-brand-icon">
                     {/* <svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 230 97" width="100px" height="60px">
                         <defs>
                             <image id="img1" href="data:image/png;base64,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">
                             </image>
                         </defs>
                         <use id="Background" href="#img1" x="0" y="0"></use>
                     </svg> */}
                      <Icons type={`Logo`} />
                 </div>
                 </div>


      <div className={`collapse navbar-collapse  ml-auto justify-content-around ${navExpanded ? 'show' : ''}`} id="navbarMain">
      <ul
        className="navbar-nav pr-2   "
      >
        {props.MenusData.map((menu, index) => {
          const hassubmenu= isSet(menu.subMenu) && menu.subMenu.length>0;
          const isactivesubmenu = hassubmenu && menu.subMenu.some(subMenuItem => currentPath===subMenuItem.link);
          let isActive =''
          if (props.activeMenu === menu.title) {
            if(isactivesubmenu){
              isActive=`${(isTabletNav && hassubmenu) ? '' : 'dropdown '}sh_activeMenu`
            }else{
            isActive = hassubmenu ? ((isTabletNav && hassubmenu) ? '' : 'dropdown ') : 'sh_activeMenu';
            }
          }else{
            isActive = hassubmenu ? ((isTabletNav && hassubmenu) ? '' : 'dropdown ') : '';
          }
          // const isActive = (props.activeMenu===menu.title)? isSet(menu.subMenu) && menu.subMenu.length>0?'dropdown ':'sh_activeMenu':'dropdown';

          let refObj = {};
          if(isSet(menu.subMenu) && menu.subMenu.length>0){
            refObj = {
              ref:menuItemRef
            }
          }
          
          return (
            <Acl acl={menu.acl} key={`acl-menu${index}`}>
              <li className={`nav-item topnavitem ${isActive}`} {...refObj} key={index}>
                <Buttons
                  className="nav-link topnavlink"
                  href={isTabletNav && hassubmenu ? '#!' : isSet(menu.link,'#!')}
                  acl={'any'}
                  extraAttr={{
                    ...(getSafeMenuAttrs(menu.attr, { isTablet: isTabletNav, hasSubmenu: hassubmenu })),
                    ...(isTabletNav && hassubmenu
                      ? {
                          onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            props.setActiveMenu(menu.title);
                            setOpenSubmenu((prev) => (prev === menu.title ? null : menu.title));
                          },
                          role: 'button',
                          'aria-expanded': openSubmenu === menu.title,
                        }
                      : {
                          onClick: () => {
                            props.setActiveMenu(menu.title);
                            setNavExpanded(false);
                          },
                        }),
                  }}
                >
                    {/* <div className="sh_sidebarnav_item"> */}
                      <span className="nav-icon">
                        <Icons type={menu.iconType} /> 
                      </span>
                      <span className="p2-light topnavtext">{menu.title}</span>
                    {/* </div> */}
                </Buttons>

                {/* Desktop: dropdown submenu */}
                {!isTabletNav && (isSet(menu.subMenu,[]).length>0) && (
                  <div
                    ref={submenuRef}
                    className="p-0 dropdown-menu shadow animated--grow-in"
                    data-bs-popper=""
                    aria-labelledby="userDropdown"
                    onClick={handleSubMenuClick}
                  >
                    {isSet(menu.subMenu, []).map((subMenuItem, subMenuIndex) => {
                      const isSubmenuActive = currentPath === subMenuItem?.link;
                      return (
                        <Acl acl={subMenuItem.acl} key={`acl-menu-submeny${subMenuIndex}`}>
                          <Buttons
                            className={`dropdown-item ${isSubmenuActive ? 'active nav-link topnavlink ' : ''}`}
                            href={isSet(subMenuItem.link, '#!')}
                            acl={'any'}
                            clickHandler={() => setNavExpanded(false)}
                          >
                            <span className="nav-icon">
                              <Icons type={subMenuItem.iconType} />
                            </span>
                            <span className={`${isSubmenuActive ? 'p2-light topnavtext ' : ''}text-wrap`} style={{ color: "#858796" }}>
                              {subMenuItem.title}
                            </span>
                          </Buttons>
                        </Acl>
                      );
                    })}
                  </div>
                )}

                {/* Tablet: collapsible submenu inside navbar collapse */}
                {isTabletNav && hassubmenu && (
                  <div className={`collapse sh_tabletNavSubmenu ${openSubmenu === menu.title ? 'show' : ''}`}>
                    <div className="pt-1 pb-2 sh_tabletNavSubmenuInner">
                      {isSet(menu.subMenu, []).map((subMenuItem, subMenuIndex) => {
                        const isSubmenuActive = currentPath === subMenuItem?.link;
                        return (
                          <Acl acl={subMenuItem.acl} key={`acl-menu-submeny-tablet${subMenuIndex}`}>
                            <Buttons
                              className={`dropdown-item ${isSubmenuActive ? 'active nav-link topnavlink ' : ''}`}
                              href={isSet(subMenuItem.link, '#!')}
                              acl={'any'}
                              clickHandler={() => {
                                setNavExpanded(false);
                                setOpenSubmenu(null);
                              }}
                            >
                              <span className="nav-icon">
                                <Icons type={subMenuItem.iconType} />
                              </span>
                              <span className={`${isSubmenuActive ? 'p2-light topnavtext ' : ''}text-wrap`} style={{ color: "#858796" }}>
                                {subMenuItem.title}
                              </span>
                            </Buttons>
                          </Acl>
                        );
                      })}
                    </div>
                  </div>
                )}
              </li>
            
            </Acl>
          );
        })}
        
      </ul>
      </div>
       <NewHeader activeMenu={props.activeMenu} notificationToogleHandler={props.notificationToogleHandler}  tutorialToogleHandler={props.tutorialToogleHandler}/> 


      {/* <Acl acl={flattenedAclArray}>
      <div className={`nav-item menu_Settings border-top ${configureActive==true?'sh_activeMenu':''}`}>
          <a
            className="nav-link js-menu-toggle no_arrow"
            href={"#"}
            onClick={(e) =>{sideBarChangeHandler();}}
            data-bs-toggle="collapse"
          >
            <div className="sh_sidebarnav_item">
            <span className="sh_menuIcon d-block">
              <Icons type="Settings" />
            </span>
            <span className="text-gray-600 sh_sidebarnav_title">Configure</span>
            </div>
          </a>
        </div>
      </Acl>
      <div className="side_Inner">
        <div className="nav-link">
          {props.Configures.map((item, index) => {
            const isActive = (props.activeMenu===item.Title)?'active':'';
            return(
              <li style={{'listStyle':'none'}} key={index}  onClick={()=>{props.setActiveMenu(item.Title)}}>
              <Buttons 
                acl={item.acl}
                accessType={'Hide'} 
                href={item.link} 
                className={`side_InnerText ${isActive}`} 
                key={index} 
                label={item.Title}/>
                </li>
              
            )
          })}
        </div>
        
      </div> */}
    </nav>
  );
};

export default NewMenus;
